export default __webpack_public_path__ + "img/liveArchive.5fbfd3d2.png";